/**
 * Custom Drawer Upsell Handler
 */
(function() {
  'use strict';

  // Upsell metaobjects store selling_plan_id as a GID
  // (gid://shopify/SellingPlan/123...), but /cart/add.js needs the numeric id —
  // bare parseInt on a GID returns NaN and the item is added WITHOUT a plan.
  // Same parsing as custom-box-sectioned.js parseSellingPlanId.
  function parseSellingPlanId(val) {
    if (!val) return null;
    const s = String(val).trim().replace('gid://shopify/SellingPlan/', '');
    const id = parseInt(s, 10);
    return Number.isFinite(id) ? id : null;
  }

  document.addEventListener('click', async (e) => {
    const upsellBtn = e.target.closest('[data-action="add-upsell"]');
    if (!upsellBtn) return;

    e.preventDefault();
    const variantId = upsellBtn.dataset.variantId;
    const discountCode = upsellBtn.dataset.discountCode;
    const sellingPlanId = upsellBtn.dataset.sellingPlanId;
    const dynamicBox = upsellBtn.dataset.dynamicBox;
    const trimmedDiscount = discountCode && discountCode.trim() !== '' ? discountCode.trim() : '';

    

    // Handle dynamic boxes via Skio flow
    let dynamicBoxId = null;
    if (dynamicBox) {
      try {
        const boxData = JSON.parse(dynamicBox);
        dynamicBoxId = boxData.box_id || null;

        if (trimmedDiscount) {
          window.dynamicBoxDiscountCode = trimmedDiscount;
        } else {
          window.dynamicBoxDiscountCode = null;
        }

        // If we don't have a variant to add, try the widget methods
        if (!variantId) {
          if (window.dynamicBoxWidget && typeof window.dynamicBoxWidget.handleAddToCart === 'function') {
            window.dynamicBoxWidget.handleAddToCart();
            return;
          } else if (window.customBoxWidget && typeof window.customBoxWidget.openWithConfig === 'function') {
            window.customBoxWidget.openWithConfig(boxData);
            return;
          } else if (window.openDynamicBox) {
            window.openDynamicBox(boxData);
            return;
          }

          alert('Kunde inte lägga till produkten. Försök igen.');
          return;
        }
      } catch (error) {
        if (!variantId) {
          alert('Kunde inte lägga till produkten. Försök igen.');
          return;
        }
      }
    }

    if (!variantId) {
      return;
    }

    const originalText = upsellBtn.textContent;
    upsellBtn.disabled = true;
    upsellBtn.textContent = 'Lägger till...';
    
    // Store reference to parent upsell card for removal after successful add
    const upsellCard = upsellBtn.closest('.upsell-card');

    const parsedSellingPlanId = parseSellingPlanId(sellingPlanId);
    let fallbackSellingPlanId = null;
    if (!parsedSellingPlanId) {
      try {
        const cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
          const subscriptionItem = (cartData.items || []).find((item) => item.selling_plan_allocation);
          fallbackSellingPlanId = subscriptionItem?.selling_plan_allocation?.selling_plan?.id || null;
        }
      } catch (error) {
        // Silent fail for fallback selling plan
      }
    }

    try {
      const cartItem = {
        id: parseInt(variantId, 10),
        quantity: 1,
      };

      if (dynamicBoxId) {
        cartItem.properties = { _dynamicBoxId: dynamicBoxId };
      }

      const formData = {
        items: [cartItem],
      };

      const chosenSellingPlan = parsedSellingPlanId || fallbackSellingPlanId;
      if (chosenSellingPlan) {
        formData.items[0].selling_plan = chosenSellingPlan;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(errorData.message || errorData.description || 'Add to cart failed');
      }

      // Hide/remove the upsell card immediately since item is now in cart
      if (upsellCard) {
        // Add fade-out animation
        upsellCard.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        upsellCard.style.opacity = '0';
        upsellCard.style.transform = 'scale(0.95)';
        
        // Remove from DOM after animation
        setTimeout(() => {
          upsellCard.remove();
          
          // If this was the last upsell, hide the entire upsell section
          const upsellSection = document.querySelector('.drawer-upsell-section');
          const remainingCards = upsellSection?.querySelectorAll('.upsell-card');
          if (upsellSection && (!remainingCards || remainingCards.length === 0)) {
            upsellSection.remove();
          }
        }, 300);
      }

      // Open cart drawer after adding items
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      } else {
        // Fallback: trigger cart drawer manually
        const drawerToggle = document.querySelector('[data-cart-drawer-toggle]');
        if (drawerToggle) {
          drawerToggle.click();
        }
      }
    } catch (error) {
      alert(`Kunde inte lägga till produkten: ${error.message}`);
      // Only reset button if it still exists in DOM (cart refresh might have removed it)
      if (upsellBtn && document.contains(upsellBtn)) {
        upsellBtn.disabled = false;
        upsellBtn.textContent = originalText;
      }
    }
  });
})();
